import { render, staticRenderFns } from "./ScanRFIDButton.vue?vue&type=template&id=65dd4df6&scoped=true&"
import script from "./ScanRFIDButton.vue?vue&type=script&lang=js&"
export * from "./ScanRFIDButton.vue?vue&type=script&lang=js&"
import style0 from "./ScanRFIDButton.vue?vue&type=style&index=0&id=65dd4df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd4df6",
  null
  
)

export default component.exports